export default __webpack_public_path__ + "448d482b6fc958925faca75692e653b6.png";